import { Origin, TargetType } from '../../../../public/assets/js/apps/TourStepEditor/store/appMode';
import {
	getWinBB
} from '../../../../public/assets/js/modules/dpitUtilsPublic';
import MobileViewPopup from './MobileViewPopup';
import { buildDpQueryString } from './dpitUtilsInc';
import urlJoin from 'url-join';

export default class MobileMenuOptionsVisualBuilderLoader {

	constructor(config) {
		this.config = config;
		this.mobileViewPopup = new MobileViewPopup(this.onMobileViewPopupExit, this.config);
	}

	openBuilder() {
		localStorage.setItem('dp_intro_tours.mobile_menu_options_origin', location.href);
		const isMobileSize = this.isMobileSize();
		const params = {
			dp_qpb_builder_mode: TargetType.MOBILE_MENU,
			dp_qpb_builder_origin: Origin.FRONTEND,
			dp_qp_run_always_on_load: 1
		};
		if (isMobileSize) params.dp_qpb_in_new_window = 1;
		const hrefNewWindow = this.getRedirectUrl(buildDpQueryString({
			dp_qpb_builder_mode: TargetType.MOBILE_MENU,
			dp_qpb_builder_origin: Origin.FRONTEND,
			dp_qp_run_always_on_load: 1,
			dp_qpb_in_new_window: !isMobileSize ? 1 : 0
		}, this.config.queryParamsDefs));
		if (!isMobileSize) {
			this.mobileViewPopup.popupCenter(hrefNewWindow, 'DP Mobile menu support', 480, window.outerHeight * 0.9);
		}
		else {
			location.href = hrefNewWindow;
		}
	}

	getRedirectUrl(queryString) {
		return urlJoin(this.config.siteUrl, queryString);
	}

	isMobileSize(breakPointOverride = null) {
		const winSize = getWinBB();
		return this.config.mobile_break_points && (winSize.width <= (breakPointOverride ? breakPointOverride : this.config.mobile_break_points?.mobile));
	}

	tryRedirectToOrigin() {
		const originHref = localStorage.getItem('dp_intro_tours.mobile_menu_options_origin');
		if (originHref) {
			localStorage.removeItem('dp_intro_tours.mobile_menu_options_origin');
			location.href = originHref;
			return true;
		}
		else return false;
	}

	onMobileViewPopupExit = (onBackdropExit = false) => {
		if (!onBackdropExit) {
			if (!this.tryRedirectToOrigin()) {
				location.reload();
			}
		}
	};
}





